import React from "react";
import WordFusionApp from "./WordFusion";

function App() {
  return <WordFusionApp />;
}

export default App;